import React from "react";

const BlogAdmin = () => {
  return <>Blog</>;
};

export default BlogAdmin;